var Backbone, SupportCancelOrderServiceActionView, SupportCancelReservationsServiceActionView, SupportEditGiftServiceActionView, SupportEditOrderServiceActionView, SupportFinePrintServiceActionView, SupportGiftOrderServiceActionView, SupportOrderFoodServiceActionView, SupportPrintGiftCardVoucherServiceActionView, SupportRedemptionInstructionsServiceActionView, SupportReturnItemsServiceActionView, SupportServiceActionMainView, SupportServiceActionsBaseView, SupportTrackOrderServiceActionView, SupportTradeInServiceActionView, SupportUpdateShippingServiceActionView, SupportViewOrderDetailsServiceActionView, SupportViewVoucherServiceActionView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportViewVoucherServiceActionView = require('./service_actions/view_voucher_service_action');

SupportTradeInServiceActionView = require('./service_actions/trade_in_service_action');

SupportCancelOrderServiceActionView = require('./service_actions/cancel_order_service_action');

SupportEditOrderServiceActionView = require('./service_actions/edit_order_service_action');

SupportGiftOrderServiceActionView = require('./service_actions/gift_order_service_action');

SupportUpdateShippingServiceActionView = require('./service_actions/update_shipping_address_service_action');

SupportTrackOrderServiceActionView = require('./service_actions/track_order_service_action');

SupportRedemptionInstructionsServiceActionView = require('./service_actions/redemption_instructions_service_action');

SupportReturnItemsServiceActionView = require('./service_actions/return_item_service_action');

SupportCancelReservationsServiceActionView = require('./service_actions/cancel_reservations_service_action');

SupportEditGiftServiceActionView = require('./service_actions/edit_gift_service_action');

SupportViewOrderDetailsServiceActionView = require('./service_actions/view_order_details_service_action');

SupportPrintGiftCardVoucherServiceActionView = require('./service_actions/print_gift_card_voucher_service_action');

SupportFinePrintServiceActionView = require('./service_actions/fine_print_service_action');

SupportOrderFoodServiceActionView = require('./service_actions/order_food_service_action');

SupportServiceActionsBaseView = require('./service_actions/service_action_base');

Backbone = require('backbone');

Backbone.$ = $;

SupportServiceActionMainView = (function(superClass) {
  extend(SupportServiceActionMainView, superClass);

  function SupportServiceActionMainView() {
    return SupportServiceActionMainView.__super__.constructor.apply(this, arguments);
  }

  SupportServiceActionMainView.prototype.id = 'serviceActionContainer';

  SupportServiceActionMainView.prototype.initialize = function(options) {
    this.options = options || {};
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    this.I18nScope = 'modules.support';
    this.serviceActions = Groupon.Support.currentOrder.serviceActions || [];
    this.constructButtonInfo();
    return this.mapViews();
  };

  SupportServiceActionMainView.prototype.constructButtonInfo = function() {
    if (this.options.showLinksAndButtons) {
      this.secondaryButtons = ['cancel_reservations', 'view_voucher', 'order_food', 'track_order', 'edit_order', 'cancel_order', 'update_shipping', 'return_item', 'trade_in'];
      this.linkButtons = ['view_order_details', 'edit_gift', 'gift_to_friend', 'redemption_instructions', 'print_gift_card_voucher', 'fine_print'];
      return this.defaultButtons = [];
    } else if (this.options.showOnlyLinks) {
      this.secondaryButtons = [];
      this.linkButtons = ['cancel_reservations', 'view_voucher', 'order_food', 'track_order', 'edit_order', 'cancel_order', 'trade_in', 'update_shipping', 'return_item', 'view_order_details', 'edit_gift', 'gift_to_friend', 'redemption_instructions', 'print_gift_card_voucher', 'fine_print'];
      return this.defaultButtons = [];
    } else {
      this.secondaryButtons = [];
      this.linkButtons = [];
      return this.defaultButtons = ['cancel_reservations', 'view_voucher', 'order_food', 'track_order', 'edit_order', 'cancel_order', 'trade_in', 'update_shipping', 'return_item', 'view_order_details', 'edit_gift', 'gift_to_friend', 'redemption_instructions', 'print_gift_card_voucher', 'fine_print'];
    }
  };

  SupportServiceActionMainView.prototype.getButtonType = function(serviceActionName) {
    if (_.contains(this.secondaryButtons, serviceActionName)) {
      return this.secondaryButtonIdentifier();
    } else if (_.contains(this.linkButtons, serviceActionName)) {
      return this.linkIdentifier();
    } else {
      return this.defaultButtonIdentifier();
    }
  };

  SupportServiceActionMainView.prototype.linkIdentifier = function() {
    return SupportServiceActionsBaseView.prototype.linkIdentifier();
  };

  SupportServiceActionMainView.prototype.defaultButtonIdentifier = function() {
    return SupportServiceActionsBaseView.prototype.defaultButtonIdentifier();
  };

  SupportServiceActionMainView.prototype.secondaryButtonIdentifier = function() {
    return SupportServiceActionsBaseView.prototype.secondaryButtonIdentifier();
  };

  SupportServiceActionMainView.prototype.mapViews = function() {
    this.map = {};
    this.map.view_order_details = {
      view: SupportViewOrderDetailsServiceActionView,
      button_type: this.getButtonType('view_order_details')
    };
    this.map.edit_gift = {
      view: SupportEditGiftServiceActionView,
      button_type: this.getButtonType('edit_gift')
    };
    this.map.cancel_reservations = {
      view: SupportCancelReservationsServiceActionView,
      button_type: this.getButtonType('cancel_reservations')
    };
    this.map.view_voucher = {
      view: SupportViewVoucherServiceActionView,
      button_type: this.getButtonType('view_voucher')
    };
    this.map.trade_in = {
      view: SupportTradeInServiceActionView,
      button_type: this.getButtonType('trade_in')
    };
    this.map.gift_to_friend = {
      view: SupportGiftOrderServiceActionView,
      button_type: this.getButtonType('gift_to_friend')
    };
    this.map.redemption_instructions = {
      view: SupportRedemptionInstructionsServiceActionView,
      button_type: this.getButtonType('redemption_instructions')
    };
    this.map.track_order = {
      view: SupportTrackOrderServiceActionView,
      button_type: this.getButtonType('track_order')
    };
    this.map.edit_order = {
      view: SupportEditOrderServiceActionView,
      button_type: this.getButtonType('edit_order')
    };
    this.map.cancel_order = {
      view: SupportCancelOrderServiceActionView,
      button_type: this.getButtonType('cancel_order')
    };
    this.map.update_shipping = {
      view: SupportUpdateShippingServiceActionView,
      button_type: this.getButtonType('update_shipping')
    };
    this.map.return_item = {
      view: SupportReturnItemsServiceActionView,
      button_type: this.getButtonType('return_item')
    };
    this.map.print_gift_card_voucher = {
      view: SupportPrintGiftCardVoucherServiceActionView,
      button_type: this.getButtonType('print_gift_card_voucher')
    };
    this.map.fine_print = {
      view: SupportFinePrintServiceActionView,
      button_type: this.getButtonType('fine_print')
    };
    return this.map.order_food = {
      view: SupportOrderFoodServiceActionView,
      button_type: this.getButtonType('order_food')
    };
  };

  SupportServiceActionMainView.prototype.render = function() {
    var action, i, len, ref, results, serviceAction, view;
    this.$el.attr('data-bhw', 'servicActions');
    ref = this.serviceActions;
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      serviceAction = ref[i];
      action = this.map[serviceAction];
      if ((action != null ? action.view : void 0) != null) {
        view = new action.view();
        view.setButtonType(action.button_type);
        view.render();
        view.$el.addClass('service-action-item').addClass(view.button_type);
        results.push(this.$el.append(view.el));
      } else {
        results.push(void 0);
      }
    }
    return results;
  };

  return SupportServiceActionMainView;

})(Backbone.View);

module.exports = SupportServiceActionMainView;

//# sourceMappingURL=data:application/json;base64,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
